import cn from 'classnames'
import React from 'react'
import { THEME } from 'src/config/config'

interface Props {
  className?: string
}

export const EnhancedTag: React.FC<Props> = ({ className }) => {
  return (
    <div
      className={cn(
        'px-3 h-[1.2rem] text-[0.8125rem] font-primary font-bold items-center text-center rounded',
        { '!rounded-full bg-[#CCE3FF] !font-tertiary font-semibold': THEME === 'ilta' },
        { '!rounded bg-turquoise': THEME === 'legaltech' },
        className,
      )}
    >
      Enhanced
    </div>
  )
}
